/*
  * @prop --component-quality-seal-markenform-color: markenform color
  * @prop --component-quality-seal-logo-color: logo color
*/

:host {
  .ui-cms-quality-seal {
    position: absolute;
    right: 0;
    width: 150px;
    z-index: 2;
    margin-right: 15px;

    @include breakpoint($medium) {
      margin-right: 30px;
      width: 200px;
    }

    @include breakpoint($desktop) {
      margin-right: 35px;
    }

    @include breakpoint($xlarge) {
      width: 250px;
      margin-right: calc((100vw - 1200px) / 2);
    }

    &__markenform {
      &--primary {
        .markenform {
          fill: var(--component-quality-seal-markenform-color, var(--skin-color-primary, $ui-blue));
        }
      }

      &--blue {
        .markenform {
          fill: var(--component-quality-seal-markenform-color, var(--ui-blue, $ui-blue));
        }
      }

      &--white {
        .markenform {
          fill: var(--component-quality-seal-markenform-color, var(--ui-color-white, $ui-white));
        }
      }
    }

    &__logo {
      &--blue {
        .logo {
          fill: var(--component-quality-seal-logo-color, var(--ui-blue, $ui-blue));
        }
      }

      &--white {
        .logo {
          fill: var(--component-quality-seal-logo-color, var(--ui-color-white, $ui-white));
        }
      }
    }
  }
}
